import editNode from './edit-node';

const editEmbed = editNode;

export default editEmbed;